import request from '@/utils/request'

// 导入公众号获取openid
export function importOpenId(data = {}) {
  return request({
    url: '/import/appid',
    method: 'POST',
    data
  })
}
